import type { IPerson } from '../model/IPerson'
import { getTodayIsoDate } from './getTodayIsoDate'

export function hasBirthday(person: IPerson) {
	return person.birthDate?.slice(4) === getTodayIsoDate().slice(4)
}
